var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlignCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.77 15.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b2b2bf;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.88,2.56H17.11a.77.77,0,1,0,0-1.54H.88a.77.77,0,0,0,0,1.54Zm0,9H17.11a.77.77,0,0,0,.78-.77.76.76,0,0,0-.78-.76H.88a.76.76,0,0,0-.77.76A.76.76,0,0,0,.88,11.57Zm0,4.5h9.64a.77.77,0,1,0,0-1.53H.88a.77.77,0,1,0,0,1.53ZM17.12,5.53H.88a.77.77,0,0,0-.77.77h0a.77.77,0,0,0,.77.76H17.12a.77.77,0,0,0,.77-.76h0A.77.77,0,0,0,17.12,5.53Zm0,9H.88a.77.77,0,0,0-.77.77h0a.77.77,0,0,0,.77.76H17.12a.77.77,0,0,0,.77-.76h0A.77.77,0,0,0,17.12,14.54Z",
    transform: "translate(-0.11 -1.02)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlignCenter);
export default __webpack_public_path__ + "static/media/icon-align-center.c52177a317598c4ad5f86161a4e3ae14.svg";
export { ForwardRef as ReactComponent };